import WidgetModule from "@eisinc/Overrides/Widgets/MyListsDetails/MyListsDetailsProductListLine";

export * from "@eisinc/Overrides/Widgets/MyListsDetails/MyListsDetailsProductListLine";

export default WidgetModule;
